import Vue from "vue"

export default new Vue()


// WEBPACK FOOTER //
// ./src/views/front/utils/bus.js